import cx from "classnames";
import Button from "../../components/Button/Button";
import PropTypes from "prop-types";

import styles from "./FiltersButtons.module.scss";

const FiltersButtons = ({
  onSave,
  onClear,
  btnEnterName,
  setSearchInput,
  className,
}) => {
  return (
    <div className={cx(styles.buttonsContainer, className)}>
      <Button
        className={styles.clearButton}
        onClick={(e) => {
          e.preventDefault();
          onClear();
        }}
      >
        Clear
      </Button>
      <Button
        className={cx(styles.saveButton)}
        onClick={(e) => {
          e.preventDefault();
          setSearchInput("");
          onSave && onSave();
        }}
      >
        {btnEnterName ? btnEnterName : "Save"}
      </Button>
    </div>
  );
};

FiltersButtons.propTypes = {
  language: PropTypes.string,
  name: PropTypes.string,
  onClear: PropTypes.func,
  setSearchInput: PropTypes.func,
  btnEnterName: PropTypes.string,
  onSave: PropTypes.func,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default FiltersButtons;
